import { getBrowserOS } from 'flow/service/util';


/**
 * determines if the modifier key is pressed across operating systems
 */
export function isPrimaryModifierPressed(event: KeyboardEvent) {
  const browserOS = getBrowserOS();
  // on windows, we want to use the "ctrl" instead of the "meta" key as the event modifier
  const eventMetaKey: keyof Pick<KeyboardEvent, 'metaKey' | 'ctrlKey'> = browserOS === 'windows'
    ? 'ctrlKey'
    : 'metaKey';

  return event[eventMetaKey];
}
